import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import State from 'store/State';

export interface SymbolInfo {
    iSymbol: string;
    bloomSymbol: string;
    assetClass: string;
    region: string;
    country: string;
    exchangeSymbol: string;
    currencyCode: string;
    description: string;
    isin: string;
    symbolIndex: string;
    industry: string;
    sector: string;
    subIndustry: string;
    superSector: string;
    securityType: string;
}

export interface SymbolInfoState {
    infos: { [iSymbol: string]: SymbolInfo };
}

export const initialSymbolInfoState: SymbolInfoState = {
    infos: {},
};

const symbolInfoSlice = createSlice({
    name: 'symbolInfoSlice',
    initialState: initialSymbolInfoState,
    reducers: {
        addSymbolInfo: (state, action: PayloadAction<SymbolInfo>) => {
            state.infos[action.payload.iSymbol] = action.payload;
        },
    },
});

export const selectSymbolInfoState = (state: State) => state.symbolInfos;

export const selectSymbolInfo = (state: State, symbol: string) =>
    selectSymbolInfoState(state).infos[symbol];

export const { addSymbolInfo } = symbolInfoSlice.actions;

export default symbolInfoSlice.reducer;
